
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndProduct",
      function () {
        return require("private-next-pages/remyndProduct/index.tsx");
      }
    ]);
  